import type { Dispatch } from 'redux';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { FETCH_COMPONENTS_REASON } from '../../common/constants/fetch-components-reason.tsx';
import { getComponentsPageRequest } from '../../state/actions.tsx';
import { get as getAnalyticsData } from '../../state/analytics/selectors.tsx';
import { patchQuery } from '../../state/query/actions.tsx';
import { getFilter } from '../../state/query/selectors.tsx';
import type { State } from '../../state/reducer.tsx';
import FilterView from './view.tsx';

const mapStateToProps = (state: State) => ({
	value: getFilter(state),
	analyticsData: getAnalyticsData(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	onChange: (value: string) => {
		dispatch(patchQuery({ filter: value, page: 1 }));
		dispatch(
			getComponentsPageRequest({
				page: 1,
				initiatedBy: FETCH_COMPONENTS_REASON.FILTERING,
			}),
		);
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(FilterView);
